export default "__VITE_ASSET__BB8MiM4___"